import { http } from '@/shared/api/axios'
import {
  NotificationsInboxResponseSchema, type NotificationsInboxResponse,
  AlertsResponseSchema, type AlertListItem,
  OrgDefaultSchema, OrgDefaultsResponseSchema, type OrgDefault, type UpsertOrgDefault,
} from './types'

export const notificationApi = {
  inbox: async (params: { pageNumber: number; pageSize: number; unreadOnly?: boolean }): Promise<NotificationsInboxResponse> => {
    const { data } = await http.get('/v1/notifications', { params })
    return NotificationsInboxResponseSchema.parse(data)
  },

  markRead: async (id: number): Promise<void> => {
    await http.post(`/v1/notifications/${id}/read`)
  },

  dismiss: async (id: number): Promise<void> => {
    await http.post(`/v1/notifications/${id}/dismiss`)
  },

  acknowledge: async (alertId: number): Promise<void> => {
    await http.post(`/v1/notifications/alerts/${alertId}/acknowledge`)
  },

  listAlerts: async (): Promise<AlertListItem[]> => {
    const { data } = await http.get('/v1/notifications/alerts')
    return AlertsResponseSchema.parse(data)
  },

  getOrgDefaults: async (): Promise<OrgDefault[]> => {
    const { data } = await http.get('/v1/notifications/preferences/org-defaults')
    return OrgDefaultsResponseSchema.parse(data)
  },

  upsertOrgDefault: async (body: UpsertOrgDefault): Promise<OrgDefault> => {
    const { data } = await http.put('/v1/notifications/preferences/org-defaults', body)
    return OrgDefaultSchema.parse(data)
  },
}
